import { getJSON, triggerSentryError } from '../helpers'
import {
  ErrorBody,
  ErrorStatus,
  ErrorTitle,
  ErrorText,
  ErrorType,
  IError,
  SentryErrorData,
  ErrorCodePrefix,
  ErrorCodeString,
  HTTPErrors,
} from '.'

export default class PBSError extends Error implements IError {
  private _errorStatus: ErrorStatus
  private _errorCode = 'undefined'
  private _errorType: ErrorType
  private _errorPath: string
  private _avoidShowingErrorScreen = false
  private _shouldTryAgainButton = false
  private _goBackButton = false
  private _okButton = false
  private _errorCodePrefix = ''
  private _textErrorCode = ''
  private _timeOutMessage = ''
  private _errorDetail = 'undefined'
  private _errorResponseData

  constructor(e: IError, errorType: ErrorType = 'DEFAULT_ERROR') {
    super(e.message || 'PBS error')
    Object.assign(this, e)
    Object.setPrototypeOf(this, new.target.prototype)
    this._errorType = errorType
    this._errorStatus = e.status || e.statusCode || ErrorStatus.DEFAULT_ERROR
    this._errorDetail = e.message || this._errorDetail
    this._errorResponseData = getJSON(e.response)
    this._errorCodePrefix = ErrorCodePrefix[errorType] || ''
    this._setTextErrorCode()
    this.configureByErrorType()
  }

  private _setTextErrorCode() {
    const httpErrorCodes = Object.values(HTTPErrors) as ErrorStatus[]
    const errorStatusAux = httpErrorCodes.includes(this._errorStatus)
      ? this._errorStatus
      : ErrorStatus.DEFAULT_ERROR

    const errorCodeStringKey =
      `${this._errorType}_${errorStatusAux}` in ErrorCodeString
        ? `${this._errorType}_${errorStatusAux}`
        : 'DEFAULT'
    this._textErrorCode =
      ErrorCodeString[errorCodeStringKey as keyof typeof ErrorCodeString]
  }

  public get errorStatus(): ErrorStatus {
    return this._errorStatus
  }
  public get errorCode(): string {
    return this._errorCode
  }
  public get errorType(): ErrorType {
    return this._errorType
  }
  public get textErrorCode(): string {
    return this._textErrorCode
  }
  public get errorPath(): string {
    return this._errorPath
  }
  public get avoidShowingErrorScreen() {
    return this._avoidShowingErrorScreen
  }
  public get shouldTryAgainButton() {
    return this._shouldTryAgainButton
  }
  public get goBackButton() {
    return this._goBackButton
  }
  public get okButton() {
    return this._okButton
  }
  public get errorCodePrefix() {
    return this._errorCodePrefix
  }
  public get timeOutMessage() {
    return this._timeOutMessage
  }
  public get errorDetail() {
    return this._errorDetail
  }

  public set textErrorCode(textErrorCode: string) {
    this._textErrorCode = textErrorCode
  }

  private configureByErrorType() {
    switch (this.errorType) {
      case 'DONATION_OAT_ERROR':
      case 'TVAULT_CONSENT_PAYLOAD_ERROR':
      case 'DONATION_CONSENT_ERROR':
        if (RegExp(/^5\d{2}$/).test(String(this.errorStatus))) {
          this._shouldTryAgainButton = true
        }
        this._goBackButton = true
        break
      case 'TVAULT_ERROR':
      case 'MVAULT_ERROR':
        if (
          this._errorResponseData &&
          this._errorResponseData.errors &&
          this._errorResponseData.errors.length > 0
        ) {
          const data = this._errorResponseData.errors[0]
          this._errorStatus = data.status || this._errorStatus
          this._errorCode = data.code || this._errorCode
          this._errorDetail = data.detail || this._errorDetail
        }
        this._timeOutMessage = 'Timeout'
        this._okButton = true
        break
      default:
        break
    }
  }

  parse(): ErrorBody {
    return {
      errorStatus: this.errorStatus,
      errorCode: '',
      errorPath: '',
      errorType: '',
      errorButtons: [],
      errorMessage: {
        errorTitle: ErrorTitle[this.errorType],
        errorText: ErrorText[this.errorType] || '',
        errorTextCode: this.textErrorCode,
        e: this,
      },
    }
  }

  static sendSentryError(se: SentryErrorData): void {
    triggerSentryError(
      se.errorString,
      se.errorTitle,
      se.extraParams,
      se.visible
    )
  }
}
